import { Admin, Resource, CustomRoutes } from 'react-admin'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { InvestmentDataPage } from './components/InvestmentDataPage'
import { InvestmentListView } from './components/InvestmentListView'
import { InvestmentPhotosPage } from './components/InvestmentPhotosPage'
import { authProvider } from './authProvider'
import { dataProvider } from './dataProvider'
import { InvestmentProvider } from './contexts/InvestmentContext'
import { ManagementProvider } from './contexts/ManagementContext'
import { PropertyList } from './components/PropertyList'
import { CustomLayout } from './components/CustomLayout'
import { LoginPage } from './components/LoginPage'
import { ResetPasswordPage } from './components/ResetPasswordPage'
import { RedirectPage } from './components/RedirectPage'
import { ManagementPanel } from './components/management'
import { customTheme } from './theme'

// Custom Layout that wraps everything in InvestmentProvider
const AppLayout = (props: any) => (
  <InvestmentProvider>
    <CustomLayout {...props} />
  </InvestmentProvider>
)

const MANAGEMENT_ENABLED = import.meta.env.VITE_MANAGEMENT_PANEL_ENABLED === 'true'

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/regulamin" element={<RedirectPage configKey="regulamin_pdf_url" />} />
        <Route path="/regulamin-zakres-uslug" element={<RedirectPage configKey="zakres_uslug_pdf_url" />} />
        <Route path="/polityka-prywatnosci" element={<RedirectPage configKey="polityka_prywatnosci_pdf_url" />} />
        {MANAGEMENT_ENABLED && (
          <Route path="/manage/*" element={
            <ManagementProvider>
              <ManagementPanel />
            </ManagementProvider>
          } />
        )}
        <Route path="/*" element={
          <Admin
            authProvider={authProvider}
            dataProvider={dataProvider}
            layout={AppLayout}
            loginPage={LoginPage}
            title="TwoPoint Panel"
            theme={customTheme}
            requireAuth
          >
            <Resource
              name="properties"
              list={PropertyList}
              options={{ label: 'Nieruchomości' }}
            />
            <CustomRoutes>
              <Route path="/inwestycje" element={<InvestmentListView />} />
              <Route path="/dane-inwestycji" element={<InvestmentDataPage />} />
              <Route path="/zdjecia" element={<InvestmentPhotosPage />} />
            </CustomRoutes>
          </Admin>
        } />
      </Routes>
    </BrowserRouter>
  )
}
